// pages/Presentation.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Presentation = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [fontSize, setFontSize] = useState(40); // Starting font size in pixels
  const [scrollProgress, setScrollProgress] = useState(0);
  const words = ['Remembrance', 'Renewal', 'Respect'];
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const maxFontSize = 120; // Maximum font size for the scaling effect
  
  // Calculate the max scroll value for each word section
  const scrollPerWord = 100 / words.length;
  
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      
      const containerHeight = containerRef.current.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;
      const progress = Math.min((scrollPosition / containerHeight) * 100, 100);
      
      setScrollProgress(progress);
      
      // Determine which word to show based on scroll progress
      const wordIndex = Math.min(
        Math.floor(progress / scrollPerWord),
        words.length - 1
      );
      
      // Calculate the font size based on progress within the current word section
      const progressInSection = (progress % scrollPerWord) / scrollPerWord;
      const newFontSize = 40 + (progressInSection * (maxFontSize - 40));
      
      setCurrentWordIndex(wordIndex);
      setFontSize(newFontSize);
      
      // If we're at the end, navigate to home page
      if (progress >= 99) {
        setTimeout(() => {
          // Use simple window.location to ensure a complete page refresh
          window.location.href = '/';
        }, 1000);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [navigate, scrollPerWord, words.length]);
  
  return (
    <div 
      ref={containerRef}
      className="bg-white min-h-screen"
      style={{ height: '300vh' }} // Make it tall enough to scroll
    >
      <div className="fixed inset-0 flex flex-col items-center justify-center">
        {/* Logo */}
        <div className="flex flex-col items-center">
          <img
            src="/images/navbar/logo.png"
            alt="Cemetery & Burial Solutions"
            className="h-56 drop-shadow-[0_18px_45px_rgba(8,45,104,0.20)] md:h-64"
          />
          
          {/* Current word with dynamic font size */}
          <div className="mt-6 flex flex-col items-center justify-center">
            <div className="text-center transition-all duration-300 ease-in-out">
              <span
                className="font-cormorant font-medium tracking-[0.06em] text-navy-800"
                style={{
                  fontSize: `${fontSize}px`,
                  lineHeight: 1.2
                }}
              >
                {words[currentWordIndex]}
              </span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Progress indicator */}
      <div className="fixed bottom-8 left-1/2 h-1 w-64 -translate-x-1/2 transform rounded-full bg-slate-200">
        <div
          className="h-full rounded-full bg-gradient-to-r from-navy-700 to-navy-500 transition-all duration-300 ease-out"
          style={{ width: `${scrollProgress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default Presentation;